import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { AtributoTemporalService } from '../../../../../services/atributo-temporal/atributo-temporal.service';
import { FichaService } from '../../../../ficha-veiculo.service';
import { ModalMessageComponent } from '../../../../../shared/modais/modal-message/modal-message.component';
import { PendenciaCaminhaoProprioInfo, VeiculoEmSeuNome } from '../../../model/veiculo';

@Component({
  selector: 'app-dados-caminhao-proprio-tempo',
  templateUrl:
    './dados-caminhao-proprio-tempo.component.html',
  styleUrls: [
    './dados-caminhao-proprio-tempo.component.scss',
  ],
})
export class DadosCaminhaoProprioTempoComponent
  implements OnInit, OnDestroy {
  @Input() value: PendenciaCaminhaoProprioInfo;
  @Output() changeForm: EventEmitter<any> = new EventEmitter();
  @Output() changeFormValid: EventEmitter<any> = new EventEmitter();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  form: FormGroup;

  temposCaminhao: any[] = [];

  listaTipoVeiculo = [];
  listaMarca = [];
  listaAnoModelo = [];
  listaModelo = [];
  listaVersao = [];

  isSelectedTipoVeiculo = false;
  isSelectedMarca = false;
  isSelectedAnoModelo = false;
  isSelectedModelo = false;
  isSelectedVersao = false;
  isSelectedCotacao = false;

  isLoadingTipoVeiculo = false;
  isLoadingMarca = false;
  isLoadingAnoModelo = false;
  isLoadingModelo = false;
  isLoadingVersao = false;

  private isAlteracao = false;

  private codigoFornecedorCotacao: string;

  private subsTipoVeiculo: Subscription;
  private subsMarca: Subscription;
  private subsAno: Subscription;
  private subsModelo: Subscription;
  private subsVersao: Subscription;
  private subsForm: Subscription;

  isSelectedMarcaAfterBlur = true;
  isSelectedAnoModeloAfterBlur = true;
  isSelectedModeloAfterBlur = true;
  isSelectedVersaoAfterBlur = true;

  constructor(
    private formBuilder: FormBuilder,
    private fichaService: FichaService,
    private atributoTemporalService: AtributoTemporalService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.getListaTemosPossuiCaminhao();
    this.watchForm();
    this.loadListaTipoVeiculo();
    this.patchForm();
  }

  private patchForm(): void {
    if (this.value) {
      this.isAlteracao = true;
      this.form.patchValue(this.value);
      if (this.value.pendencia) {
        this.onChangeMarca(null);
        this.onChangeAnoModelo(null);
        this.onChangeModelo(null);
        this.isSelectedVersao = true;
      }
    }
  }

  ngOnDestroy() {
    if (this.subsTipoVeiculo) {
      this.subsTipoVeiculo.unsubscribe();
    }
    if (this.subsMarca) {
      this.subsMarca.unsubscribe();
    }
    if (this.subsModelo) {
      this.subsModelo.unsubscribe();
    }
    if (this.subsAno) {
      this.subsAno.unsubscribe();
    }
    if (this.subsVersao) {
      this.subsVersao.unsubscribe();
    }
    if (this.subsForm) {
      this.subsForm.unsubscribe();
    }
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      veiculoPlaca: '',
      veiculoCategoria: 4,
      veiculoMarca: '',
      veiculoAno: '',
      veiculoModelo: '',
      veiculoVersao: '',
      tempoCaminhao: null,
    });
  }

  private async getListaTemosPossuiCaminhao() {
    try {
      const response = await this.atributoTemporalService.listar('TEMPO_POSSUI_CAMINHAO');
      this.temposCaminhao = response || [];
    } catch (error) {
      this.modalMessage.show(
        'Falha ao listar as opções "Tempo que possuí o Caminhão Próprio".'
      );
    }
  }

  private watchForm(): void {
    this.subsForm = this.form.valueChanges.subscribe(() => {
      this.changeForm.emit(this.form.value);
      this.changeFormValid.emit(this.formValid);
    });
  }

  clearList(lista: string[]) {
    if (!this.isAlteracao  && lista && lista.length) {
      lista.forEach((item) => {
        switch (item) {
          case 'TipoVeiculo': {
            this.listaTipoVeiculo = [];
            this.isSelectedTipoVeiculo = false;
            this.form.get('veiculoCategoria').setValue(4);
            this.onSelectedTipoVeiculoChange();
            break;
          }
          case 'Marca': {
            this.listaMarca = [];
            this.isSelectedMarca = false;
            this.form.get('veiculoMarca').setValue('');
            this.onSelectedMarcaChange();
            break;
          }
          case 'AnoModelo': {
            this.listaAnoModelo = [];
            this.isSelectedAnoModelo = false;
            this.form.get('veiculoAno').setValue('');
            this.onSelectedAnoModeloChange();
            break;
          }
          case 'Modelo': {
            this.listaModelo = [];
            this.isSelectedModelo = false;
            this.form.get('veiculoModelo').setValue('');
            this.onSelectedModeloChange();
            break;
          }
          case 'Versao': {
            this.listaVersao = [];
            this.isSelectedVersao = false;
            this.form.get('veiculoVersao').setValue('');
            break;
          }
        }
      });
      this.isSelectedMarcaAfterBlur = true;
      this.isSelectedAnoModeloAfterBlur = true;
      this.isSelectedModeloAfterBlur = true;
      this.isSelectedVersaoAfterBlur = true;
    }
  }

  loadListaTipoVeiculo() {
    this.clearList(['TipoVeiculo', 'Marca', 'AnoModelo', 'Modelo', 'Versao']);
    this.isLoadingTipoVeiculo = true;
    this.subsTipoVeiculo = this.fichaService
      .getTipoVeiculo()
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingTipoVeiculo = false;
        })
      )
      .subscribe((res) => {
        if (res.tipos) {
          res.tipos.forEach((tipo) => {
            if ([4].includes(tipo.id)) {
              this.listaTipoVeiculo.push(tipo);
              this.form.get('veiculoCategoria').setValue(tipo.id);
              this.form.get('veiculoCategoria').disable();
              this.loadListaMarca();
            }
          });
        }
      });
  }

  loadListaMarca() {
    this.clearList(['Marca', 'AnoModelo', 'Modelo', 'Versao']);
    this.isLoadingMarca = true;
    this.subsMarca = this.fichaService
      .getMarcaPorTipo(this.veiculoCategoria)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingMarca = false;
        })
      )
      .subscribe((res) => {
        this.listaMarca = res.marcas;
        if (this.isAlteracao && this.value && this.value.veiculoMarca) {
          const veiculoMarca = this.listaMarca.find(
            (f) => f.id === this.value.veiculoMarca.id
          );
          this.form.get('veiculoMarca').setValue(veiculoMarca);
        }
        this.resetAlteracao();
      });
  }

  loadListaAnoModelo() {
    this.clearList(['AnoModelo', 'Modelo', 'Versao']);

    this.isLoadingAnoModelo = true;
    this.subsAno = this.fichaService
      .getAnoModeloPorMarca(this.veiculoCategoria, this.veiculoMarca)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingAnoModelo = false;
        })
      )
      .subscribe(
        (res) => this.handleListaAnoModelo(res.anosModelo),
        (error) => {
          this.modalMessage.show(
            'Não há ano de veículo para as características selecionadas.'
          );
        }
      );
  }

  private handleListaAnoModelo(anos) {
    this.listaAnoModelo = anos;
    this.resetAlteracao();
  }

  resetAlteracao() {
    if (
      !this.isLoadingTipoVeiculo &&
      !this.isLoadingMarca &&
      !this.isLoadingAnoModelo &&
      !this.isLoadingModelo &&
      !this.isLoadingVersao
    ) {
      this.isAlteracao = false;
    }
  }

  loadListaModelo() {
    this.clearList(['Modelo', 'Versao']);
    this.isLoadingModelo = true;
    this.subsModelo = this.fichaService
      .getModeloPorMarcaAno(
        this.veiculoCategoria,
        this.veiculoMarca,
        this.veiculoAno
      )
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingModelo = false;
        })
      )
      .subscribe(
        (res) => {
          this.listaModelo = res.modelos;
          if (this.isAlteracao && this.value && this.value.veiculoModelo) {
            const veiculoModelo = this.listaModelo.find(
              (f) => f.id === this.value.veiculoModelo.id
            );
            this.form.get('veiculoModelo').setValue(veiculoModelo);
          }
          this.resetAlteracao();
        },
        () =>
          this.modalMessage.show(
            ' Não há modelo de veículo para as características selecionadas.'
          )
      );
  }

  loadListaVersao() {
    this.clearList(['Versao']);
    this.isLoadingVersao = true;
    this.subsVersao = this.fichaService
      .getVersaoPorMarcaModeloAno(
        this.veiculoCategoria,
        this.veiculoMarca,
        this.veiculoAno,
        this.veiculoModelo
      )
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingVersao = false;
        })
      )
      .subscribe(
        (res) => {
          this.listaVersao = res.versoes;
          if (this.isAlteracao && this.value && this.value.veiculoVersao) {
            const veiculoVersao = this.listaVersao.find(
              (f) => f.id === this.value.veiculoVersao.id
            );
            this.form.get('veiculoVersao').setValue(veiculoVersao);
          }
          this.resetAlteracao();
        },
        (error) => {}
      );
  }

  onChangeMarca(event) {
    this.isSelectedMarca = true;
    this.loadListaAnoModelo();
    this.onSelectedMarcaChange();
  }

  onChangeAnoModelo(event) {
    this.isSelectedAnoModelo = true;
    this.loadListaModelo();
    this.onSelectedAnoModeloChange();
  }

  onChangeModelo(event) {
    this.isSelectedModelo = true;
    this.loadListaVersao();
    this.onSelectedModeloChange();
  }

  onChangeVersao(event) {
    this.codigoFornecedorCotacao = this.listaVersao[event.target.selectedIndex - 1].codigoMolicar;
    this.isSelectedVersao = true;
  }

  onBlurMarca(event) {
    this.isSelectedMarcaAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurAnoModelo(event) {
    this.isSelectedAnoModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurModelo(event) {
    this.isSelectedModeloAfterBlur = event.target.selectedIndex > 0;
  }

  onBlurVersao(event) {
    this.isSelectedVersaoAfterBlur = event.target.selectedIndex > 0;
  }

  public get veiculoCategoria(): string {
    return (
      this.form &&
      this.form.get('veiculoCategoria') &&
      this.form.get('veiculoCategoria').value
    );
  }

  public get veiculoMarca(): string {
    return (
      this.form &&
      this.form.get('veiculoMarca') &&
      this.form.get('veiculoMarca').value &&
      this.form.get('veiculoMarca').value.id
    );
  }

  public get veiculoAno(): string {
    return (
      this.form &&
      this.form.get('veiculoAno') &&
      this.form.get('veiculoAno').value
    );
  }

  public get veiculoModelo(): string {
    return (
      this.form &&
      this.form.get('veiculoModelo') &&
      this.form.get('veiculoModelo').value &&
      this.form.get('veiculoModelo').value.id
    );
  }

  public get veiculoVersao(): string {
    return (
      this.form &&
      this.form.get('veiculoVersao') &&
      this.form.get('veiculoVersao').value &&
      this.form.get('veiculoVersao').value.id
    );
  }

  public get veiculoPlaca(): string {
    return this.value && this.value.veiculoPlaca;
  }

  public get formValid(): boolean {
    const {
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
      tempoCaminhao,
    } = this.form.getRawValue();

    if (this.isErroConsulta) {
      return !!(
        veiculoCategoria &&
        veiculoMarca &&
        veiculoAno &&
        veiculoModelo &&
        veiculoVersao &&
        tempoCaminhao
      );
    }

    return !!tempoCaminhao;
  }

  public get descricaoVeiculo(): string {
    const {
      veiculoMarca,
      veiculoModelo,
      veiculoVersao,
      veiculoAno,
      pendencia,
    } = this.value;
    if (pendencia) return '';
    return `${veiculoMarca.descricao} ${veiculoModelo.descricao} ${veiculoVersao.descricao} ${veiculoAno}`;
  }

  public get isErroConsulta(): boolean {
    return this.value && this.value.pendencia;
  }

  onSelectedTipoVeiculoChange() {
    if (this.isSelectedTipoVeiculo) {
      this.form.get('veiculoMarca')?.enable();
    } else {
      this.form.get('veiculoMarca')?.disable();
    }
  }

  onSelectedMarcaChange() {
    if (this.isSelectedMarca) {
      this.form.get('veiculoAno')?.enable();
    } else {
      this.form.get('veiculoAno')?.disable();
    }
  }

  onSelectedAnoModeloChange() {
    if (this.isSelectedAnoModelo) {
      this.form.get('veiculoModelo')?.enable();
    } else {
      this.form.get('veiculoModelo')?.disable();
    }
  } 
  onSelectedModeloChange() {
    if (this.isSelectedModelo) {
      this.form.get('veiculoVersao')?.enable();
    } else {
      this.form.get('veiculoVersao')?.disable();
    }
  }

}
